import React from 'react';

import * as css from './Preloader.scss';

const Preloader = () => {
	return (
		<div className={css.preloader}>
			<div className={css.ballScaleMultiple}>
				<div />
				<div />
				<div />
			</div>
		</div>
	);
};

export default Preloader;
